import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=661d2995&scoped=true&lang=pug&"
import script from "./Meta.vue?vue&type=script&lang=js&"
export * from "./Meta.vue?vue&type=script&lang=js&"
import style0 from "./Meta.vue?vue&type=style&index=0&id=661d2995&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d2995",
  null
  
)

/* custom blocks */
import block0 from "./Meta.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports